<template>
  <div class="row pt-2">
    <div class="col" v-if="modifierButton">
      <Button label="Modifier" @click="modifier" :disabled="isSauvegardeEnCours"/>
    </div>
    <div class="col">
      <div v-if="isApprouvable && actionAccesDecision.approbationActionDecisionDO" >
        <Button label="Approuver" @click="approuver" :disabled="isSauvegardeEnCours"/>
      </div>
      <div v-if="isPermettreModifier && actionAccesDecision.modifierActionDecisionDO" >
        <Button label="Permettre modification" @click="permettreModifier" :disabled="isSauvegardeEnCours"/>
      </div>
      <div v-if="actionAccesDecision.auditAccesActionDecision">
        <Button label="Audit des accès" @click="auditAcces" :disabled="isSauvegardeEnCours"/>
      </div>
      <div v-if="actionAccesDecision.auditChangementsActionDecision">
        <Button label="Audit des modifications" @click="auditModifications" :disabled="isSauvegardeEnCours"/>
      </div>
<!--      <div v-if="actionAccesDecision.imprimerCompletActionDecision">-->
      <div>
        <Button label="Imprimer" @click="imprimerNarration" :disabled="isSauvegardeEnCours"/>
      </div>
    </div>
    <div class="col">
      <Button label="Fermer" @click="fermer"/>
    </div>
  </div>
</template>

<script>

export default {
    name: "ButtonBar",
    props: ['actionAccesDecision', 'modifierButton', 'isSauvegardeEnCours', 'isApprouvable', 'isPermettreModifier'],
    emits: ['fermer', 'modifier', 'auditModifications', 'auditAcces', 'approuver', 'permettreModifier', 'imprimerNarration'],
    data() {
        return {
            rapConsultDossierValeur: null,
        }
    },
    methods: {
        auditAcces() {
            this.$emit('auditAcces');
        },
        auditModifications() {
            this.$emit('auditModifications');
        },
        modifier() {
            this.$emit('modifier');
        },
        approuver(){
            this.$emit('approuver');
        },
        permettreModifier() {
          this.$emit('permettreModifier');
        },
        imprimerNarration() {
            this.$emit('imprimerNarration');
        },
        fermer() {
            this.$emit('fermer');
        },
    }
}
</script>